<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="false"
        :collapse-transition="false"
        mode="vertical"
        :default-openeds="openeds"
        ref="menu"
        :key="menuKey"
      >
        <sidebar-item v-for="(route, index) in permission_routes" :key="index" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      aaa: [
        // 这个aaa是我测试的时候写的一个数组就是看看能不能改变 左侧栏答案是可以的 首先 path是必须的 路径你和你们的后台商量怎么写，
        // 但是必须匹配你的组件名 meta必须的这是展示在左侧的标题  如果有下级就加上children
        {
          // 我的工作
          path: '/dashboard',
          meta: { title: '我的工作', icon: 'work' },
          children: [
            {
              path: 'index',
              component: () => import('@/views/dashboard/index'),
              meta: { title: '待办任务', icon: '00', noCache: true }
            },
            {
              path: 'readytask',

              meta: { title: '已办任务', icon: '00', noCache: true }
            },
            {
              path: 'endtask',

              meta: { title: '办结任务', icon: '00', noCache: true }
            }
          ]
        }
      ],
      openeds: ['/deliver', '/behalfOfOthers', '/setting', '/shop', '/operation', '/statistics', '/more'],
      menuKey: 0
    }
  },
  computed: {
    ...mapGetters(['permission_routes', 'sidebar']),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  watch: {
    isCollapse(newVal) {
      if (!newVal) {
        this.menuKey++
      }
    }
  },
  mounted() {
    console.log(this.permission_routes)
  }
}
</script>
